import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { softwareReportsRoute } from '@atlassian/jira-router-routes-next-gen-routes/src/softwareReportsRoute.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { reportsOverviewPageEntryPoint as reportsOverviewPageEntry } from '@atlassian/jira-reports-overview-page/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import { getTMPReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import { reportsOverviewPageEntrypoint as oldReportsOverviewPageEntrypoint } from './ui/software/reports/overview/index.tsx';

const tmpReportsOverviewPageEntrypoint = createPageEntryPoint({
	main: reportsOverviewPageEntry,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

// TMP Reports route
export const softwareReportsRouteEntry = createEntry(softwareReportsRoute, () => ({
	group: 'software',
	layout: softwareProjectLayoutNoOnboarding,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarNextGen,
		horizontal: AsyncHorizontalNavJira,
		onlyShowHorizontalOnNav4: true,
	},
	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticSidebarShortcutsResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...getTMPReportsCommonResource(),
	],
	entryPoint() {
		return fg('uxissue_545_migrate_tmp_reports_overview_page')
			? tmpReportsOverviewPageEntrypoint
			: oldReportsOverviewPageEntrypoint;
	},
	ufoName: 'software-reports.overview',

	supportsPreviewPanel: true,
}));
